import { render, staticRenderFns } from "./SkupTemaBase.vue?vue&type=template&id=105598d9&scoped=true&"
import script from "./SkupTemaBase.vue?vue&type=script&lang=js&"
export * from "./SkupTemaBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105598d9",
  null
  
)

export default component.exports